module.exports = __webpack_public_path__ + "img/16Ox6OO.d41d8cd9.svg";